module.exports = __webpack_public_path__ + "img/JMB.d22648b9.jpg";